import OrdersBackendRoutes from '../api/OrdersBackendRoutes';
import { ICartApiAccessTokenData } from '../common/interfaces/cart-api.interface';

export default class OrdersBackendService {
  public async getAccessToken(): Promise<ICartApiAccessTokenData> {
    return OrdersBackendRoutes.getAccessToken.fetch();
  }
}
